export default __webpack_public_path__ + "static/multi-ai-dark-04357f47d107e2e4bf0136510b4366d38f3cde185eeb1ff5a707a12605a968eb.png";